import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.array.find";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "C:/works/xiangyun/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getCompanyList, selCurrent } from '@/api/user.js';
export default {
  name: 'RelevanceCompany',
  components: {},
  props: {
    message: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      loading: false,
      list: [],
      current: ''
    };
  },
  watch: {
    visible: {
      handler: function handler(v) {
        this.dialogVisible = v;
        if (v) {
          this.loading = true;
          this.getList();
        }
      },
      immediate: true
    }
  },
  methods: {
    handleClose: function handleClose() {
      this.$emit('close');
    },
    goAdd: function goAdd() {
      this.$emit('add');
    },
    getList: function () {
      var _getList = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _res$data$find, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return getCompanyList();
            case 3:
              res = _context.sent;
              this.loading = false;
              this.list = res.data;
              this.current = (_res$data$find = res.data.find(function (item) {
                return item.isOption === 1;
              })) === null || _res$data$find === void 0 ? void 0 : _res$data$find.id;
              _context.next = 12;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              this.loading = false;
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 9]]);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    changeActive: function changeActive(id) {
      this.current = id;
    },
    ok: function () {
      var _ok = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this = this;
        var item;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              item = this.list.find(function (item) {
                return item.id === _this.current;
              });
              if (!(!item.expireTime || new Date(item.expireTime.replace(/-/g, '/')).getTime() - Date.now() <= 0)) {
                _context2.next = 5;
                break;
              }
              this.$confirm('当前企业核验已过期，请进行核验?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(function () {
                _this.$emit('check', {
                  code: item.tyshxydm,
                  erpId: item.id
                });
              }).catch(function () {});
              _context2.next = 10;
              break;
            case 5:
              this.loading = true;
              _context2.next = 8;
              return selCurrent({
                id: item.id,
                isOption: 1
              });
            case 8:
              this.loading = false;
              this.$emit('success');
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function ok() {
        return _ok.apply(this, arguments);
      }
      return ok;
    }()
  }
};